import { createStore } from '@stencil/store';

import { AffiliateControllerResponse } from '../../../types/controllers/affiliate';

type Store = {
    location: string | null;
    placements: {
        [key: string]: { isLoading: boolean; data: AffiliateControllerResponse | null };
    };
    observer: IntersectionObserver | null;
    elementRegister: Map<HTMLElement, (el: HTMLElement) => void>;
    ctaShown: boolean;
};

const { state, ...store } = createStore<Store>({
    location: null,
    placements: {},
    observer: null,
    elementRegister: new Map(),
    ctaShown: false,
});

type PlacementValues = {
    isLoading: boolean;
    data: AffiliateControllerResponse | null;
};

export const getPlacementFromStore = (key: string): PlacementValues | null => {
    return state.placements[key] || null;
};

export const setPlacementToStore = (key: string, values: PlacementValues) => {
    state.placements[key] = values;
};

export const setLocationToStore = (location: string | null) => {
    state.location = location;
};

export const getCtaStatus = () => {
    return state.ctaShown;
};

export const setCtaStatus = (status: boolean) => {
    state.ctaShown = status;
};

export const stencilStore = store;

export default state;
